module.exports = __webpack_public_path__ + "static/img/bcg.80c98749.jpg";